// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"532":"d27484a5","647":"157c9e2a","891":"ae763eb8","956":"419a79c5"}[chunkId] + ".css";
};